import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Title = styled.h3`
  font-weight: 700;
  font-size: 24px;
  color: ${colors.primary};
`
export const Subtitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: ${colors.gray7};
  padding-top: 16px;
`
export const Text = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: ${colors.primary};
`
